import { useMutation } from "@apollo/client/react";
import { ImportOutlined } from "@ant-design/icons";
import { css } from "@linaria/core";
import { App, Button, Modal } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { type GenericIngredientFragment, UpdateIngredientDocument } from "../../../gql/generated/graphqlSchema.tsx";
import { useSaving } from "../../../hooks/useSaving.tsx";
import { useIngredient } from "../IngredientContext.tsx";
import { GenericIngredientSearch } from "./GenericIngredientSearch.tsx";

const modalBody = css`
  height: 620px;
  padding: 0;
`;

export const ImportNutritionModal = () => {
  const { t } = useTranslation();
  const { message } = App.useApp();
  const { ingredient, setIngredient, units } = useIngredient();
  const { trackSaving } = useSaving();
  const [updateIngredient] = useMutation(UpdateIngredientDocument);

  const [open, setOpen] = useState(false);

  const gramsUnitId = units.find((u) => u.code === "g")?.id;

  const handleSelect = (gi: GenericIngredientFragment) => {
    const np = gi.nutritionProfile;
    trackSaving(() =>
      updateIngredient({
        variables: {
          id: ingredient.id,
          input: {
            genericIngredientId: gi.id,
            fat: np.fat,
            saturatedFat: np.saturatedFat,
            carbohydrate: np.carbohydrate,
            sugars: np.sugars,
            fibre: np.fibre,
            protein: np.protein,
            salt: np.salt,
            alcohol: np.alcohol,
            nutritionReferenceQuantity: 100,
            nutritionReferenceUnitId: gramsUnitId,
          },
        },
      }).then((result) => {
        setIngredient(result.data?.updateIngredient.refreshedIngredient);
        setOpen(false);
        message.success(t("ingredients.nutrition.importDone"));
      }),
    );
  };

  return (
    <>
      <Button color="primary" icon={<ImportOutlined />} onClick={() => setOpen(true)} variant="outlined">
        {t("ingredients.nutrition.importButton")}
      </Button>

      <Modal
        classNames={{ body: modalBody }}
        destroyOnHidden
        footer={null}
        onCancel={() => setOpen(false)}
        open={open}
        title={t("ingredients.nutrition.importTitle")}
        width={1200}
      >
        <GenericIngredientSearch
          actionLabel={t("ingredients.nutrition.importAction")}
          onCancel={() => setOpen(false)}
          onSelect={handleSelect}
        />
      </Modal>
    </>
  );
};
